const rankingData = [
  {
    rank: 1,
    name: '香蕉视频',
    tag: '本周最热',
    desc: '内容资源丰富，更新频率领先，高清片源覆盖广泛题材',
    viewers: '98.6万',
    trend: 'up',
    color: 'primary',
  },
  {
    rank: 2,
    name: '红桃视频',
    tag: '口碑推荐',
    desc: '原创内容独家首发，播放流畅度在同类平台中名列前茅',
    viewers: '87.3万',
    trend: 'up',
    color: 'accent',
  },
  {
    rank: 3,
    name: '91视频',
    tag: '新晋热门',
    desc: '社区互动活跃，用户评价持续走高，近期内容质量大幅提升',
    viewers: '72.1万',
    trend: 'up',
    color: 'primary',
  },
  {
    rank: 4,
    name: '蜜桃视频',
    tag: '品质之选',
    desc: '专注高清画质体验，播放器技术优化出色，真正做到不缓冲',
    viewers: '65.8万',
    trend: 'stable',
    color: 'secondary',
  },
  {
    rank: 5,
    name: '樱花视频',
    tag: '快速成长',
    desc: '近三月访问量激增，界面简洁友好，新用户上手体验极佳',
    viewers: '51.4万',
    trend: 'up',
    color: 'secondary',
  },
  {
    rank: 6,
    name: '糖豆视频',
    tag: '潜力新星',
    desc: '特色内容差异化明显，小众题材覆盖周全，深耕垂直领域',
    viewers: '38.9万',
    trend: 'up',
    color: 'secondary',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            数据榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            基于用户访问热度、内容更新频率与播放体验综合评估的影视平台实时排名
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  <span className="text-lg font-heading font-bold">{item.rank}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-base font-semibold text-foreground-900">{item.name}</h3>
                    <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
                      item.color === 'primary' ? 'bg-primary-100 text-primary-700' :
                      item.color === 'accent' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1.5">
                      <i className="ri-eye-line text-xs text-foreground-400"></i>
                      <span className="text-xs text-foreground-600 font-medium">{item.viewers}</span>
                    </div>
                    <span className={`text-xs font-medium ${
                      item.trend === 'up' ? 'text-primary-600' : 'text-foreground-500'
                    }`}>
                      {item.trend === 'up' ? '↑ 上升' : '→ 稳定'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}